import {
  type ButtonHTMLAttributes,
  type FC,
  type MouseEventHandler,
  type ReactNode,
} from 'react'

interface ButtonTertiaryProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode
  onClick?: MouseEventHandler<HTMLButtonElement>
}

const ButtonTertiary: FC<ButtonTertiaryProps> = ({
  children,
  className,
  ...props
}) => (
  <button {...props} className={`relative group ${className ?? ''}`}>
    <span
      className={`block relative p-2 text-white bg-neonlime-500 shadow-neonlime-550 font-figtree rounded-xl text-lg leading-none w-full transition  group-hover:translate-y-0.5 [box-shadow:0px_0.162rem_0px_0px_var(--tw-shadow-color)_inset,0px_-0.270rem_0px_0px_rgba(0,0,0,0.25)_inset] group-hover:[box-shadow:0px_0.162rem_0px_0px_transparent_inset,0px_-0.270rem_0px_0px_transparent_inset]`}
    >
      {children}
    </span>
  </button>
)

export default ButtonTertiary
